/** @flow */
import * as React from 'react';
import { translate } from 'react-i18next';
import DayMetricCard from './DayMetricPrintingElement';
import type ComparedMetric from '../../domain/DashboardData';

type Props = {
  sundayMetric: ?ComparedMetric;
  saturdayMetric: ?ComparedMetric;
  t: any,
};

function WeekendMetricPrintingElement({ sundayMetric, saturdayMetric, t }: Props) {
  return (
    <React.Fragment>
      { saturdayMetric &&
        <DayMetricCard
          day={t('dayOfWeek.saturday')}
          metric={saturdayMetric}
        />
      }
      { sundayMetric &&
        <DayMetricCard
          day={t('dayOfWeek.sunday')}
          metric={sundayMetric}
        />
      }
    </React.Fragment>
  );
}

export default translate()(WeekendMetricPrintingElement);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/printing/components/WeekendMetricPrintingElement.js